import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IGetUserSettingsParams {
  username: string;
  domainName: string;
}

export interface IGetUserSettingsResult extends IResult {
  language: string;
  locale: string;
  timeZoneId: string;
  email: string;
  startPage: string;
}

export class GetUserSettingsRequest extends Request<IGetUserSettingsParams, IGetUserSettingsResult> {
  constructor(params: IGetUserSettingsParams) {
    super('getUserSettings', params);
  }
}
